var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.001,
    height: 29,
    viewBox: "0 0 94.001 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoice",
    transform: "translate(-1143.999 -188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_payment-invoice-sign-alt-o",
    "data-name": "Icon payment-invoice-sign-alt-o",
    d: "M34.357,22.322a3.961,3.961,0,0,1,.767,1.151,3.282,3.282,0,0,1,.274,1.37V42.926a1.312,1.312,0,0,1-.438,1.041,1.421,1.421,0,0,1-1.041.439H12.877a1.417,1.417,0,0,1-1.041-.438,1.309,1.309,0,0,1-.438-1.041v-25.1a1.31,1.31,0,0,1,.438-1.041,1.42,1.42,0,0,1,1.041-.438H26.9a3.262,3.262,0,0,1,1.37.329,4.124,4.124,0,0,1,1.205.713l4.877,4.931Zm-.931,20.055v-16H26.9a1.417,1.417,0,0,1-1.041-.438,1.375,1.375,0,0,1-.438-1.1V18.377H13.37v24H33.425ZM17.37,28.9a.529.529,0,0,1,.164-.384.472.472,0,0,1,.329-.164H28.933a.474.474,0,0,1,.329.164.527.527,0,0,1,.164.384v.986q0,.275-.164.329a.475.475,0,0,1-.329.164H17.863a.474.474,0,0,1-.329-.164q-.164-.054-.164-.329V28.9ZM28.932,32.4a.449.449,0,0,1,.329.109.527.527,0,0,1,.164.384v.986a.527.527,0,0,1-.164.384.835.835,0,0,1-.329.109H17.863a.827.827,0,0,1-.329-.109.526.526,0,0,1-.164-.384V32.9a.529.529,0,0,1,.164-.384.446.446,0,0,1,.329-.109Zm0,4a.844.844,0,0,1,.329.109.527.527,0,0,1,.164.384v.986a.527.527,0,0,1-.164.384.835.835,0,0,1-.329.109H17.863a.827.827,0,0,1-.329-.109.526.526,0,0,1-.164-.384V36.9a.529.529,0,0,1,.164-.384.837.837,0,0,1,.329-.109ZM27.4,18.486V24.35h5.918a1,1,0,0,0-.384-.6l-4.877-4.932a1.8,1.8,0,0,0-.658-.329Z",
    transform: "translate(1132.602 171.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Kauf_auf_Rechnung",
    "data-name": "Kauf aufRechnung",
    transform: "translate(1178 201)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Inter",
    letterSpacing: "0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KAUF AUF"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 14
  }, "RECHNUNG")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceFooter);
export default __webpack_public_path__ + "static/media/invoice_footer.f76befeb3f0f34f9aba7f281173a9b06.svg";
export { ForwardRef as ReactComponent };